type ClarityCommand = (...args: unknown[]) => void;

declare global {
  interface Window {
    clarity?: ClarityCommand;
  }
}

function call(...args: unknown[]): void {
  window.clarity?.(...args);
}

export function clarityEvent(name: string): void {
  call("event", name);
}

export function clarityTag(key: string, value: string): void {
  if (value === "") return;
  call("set", key, value);
}
